"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagRallyDriversProperty = exports.tagRallyDriversPropertyDefinition = void 0;
exports.tagRallyDriversPropertyDefinition = {
    name: 'tag-rally-drivers',
    type: 'asset',
    multiple: true,
    view: {
        hint: 'Related to a rally driver? Tag it and the asset shows on the rally driver collection page.',
        label: 'Rally Drivers',
        style: '',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['rally-driver'],
        },
    ],
};
const isTagRallyDriversProperty = (prop) => {
    return prop.name === exports.tagRallyDriversPropertyDefinition.name;
};
exports.isTagRallyDriversProperty = isTagRallyDriversProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLXJhbGx5LWRyaXZlcnMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90YWctcmFsbHktZHJpdmVycy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRSxtQkFBbUI7SUFDekIsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRTtRQUNKLElBQUksRUFBRSw0RkFBNEY7UUFDbEcsS0FBSyxFQUFFLGVBQWU7UUFDdEIsS0FBSyxFQUFFLEVBQUU7S0FDVjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsY0FBYyxDQUFDO1NBQzNCO0tBQ0Y7Q0FDOEIsQ0FBQTtBQUkxQixNQUFNLHlCQUF5QixHQUFHLENBQUMsSUFBa0IsRUFBbUMsRUFBRTtJQUMvRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQzdELENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9